import { AlertTriangle, ShieldAlert } from "lucide-react";
import type { BreachRecord } from "@/components/intel/BreachRecordsList";

export function BreachExposureBanner({ breaches }: { breaches: BreachRecord[] }) {
  if (!breaches.length) return null;
  const hasPasswords = breaches.some((b) => (b.dataClasses ?? []).some((c: string) => /password/i.test(c)));
  const anyVerified = breaches.some((b) => b.verified);
  const variant: "critical" | "high" | "medium" = hasPasswords ? "critical" : anyVerified ? "high" : "medium";
  const mostRecent = breaches
    .map((b) => b.date)
    .filter(Boolean)
    .sort()
    .slice(-1)[0];

  const cls =
    variant === "critical"
      ? "border-danger/60 bg-danger/10 text-danger"
      : variant === "high"
      ? "border-[oklch(0.72_0.20_50)]/60 bg-[oklch(0.72_0.20_50)]/10 text-[oklch(0.82_0.20_50)]"
      : "border-amber/60 bg-amber/10 text-amber";

  const label =
    variant === "critical"
      ? "CREDENTIAL EXPOSURE — PASSWORDS LEAKED"
      : variant === "high"
      ? "VERIFIED BREACH EXPOSURE"
      : "BREACH EXPOSURE DETECTED";

  return (
    <div className={`rounded-md border px-3 py-2.5 flex items-start gap-3 ${cls}`}>
      {variant === "critical" ? (
        <ShieldAlert className="h-5 w-5 mt-0.5 flex-shrink-0" />
      ) : (
        <AlertTriangle className="h-5 w-5 mt-0.5 flex-shrink-0" />
      )}
      <div className="flex-1 min-w-0">
        <div className="font-mono text-[10px] uppercase tracking-[0.25em]">{label}</div>
        <div className="mt-0.5 text-sm">
          Subject email appears in <strong>{breaches.length}</strong> known breach{breaches.length === 1 ? "" : "es"}
          {mostRecent ? ` (most recent: ${mostRecent})` : ""}
          {hasPasswords ? " — passwords compromised." : "."}
        </div>
        <a
          href="#breach-records"
          className="mt-1 inline-block text-xs underline underline-offset-2 opacity-80 hover:opacity-100"
        >
          View breach records ↓
        </a>
      </div>
    </div>
  );
}